import { useContext } from 'react'
import { FtteContext } from '../components/FtteProvider/FtteProvider'

export default function useContextData() {
  const contextData = useContext(FtteContext)
  return contextData ?? {}
}
